import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { Card, Button, Row, Col } from "react-bootstrap"
import WelcomeQuiz from "./WelcomeQuiz"
import { useFeatureFlagEnabled } from "posthog-js/react"
import { useTranslation } from "react-i18next"
import Skeleton from "@/components/common/skeleton"
import tryMazoom from "@/assets/images/tryMazoom.svg" // Adjust the path as necessary
import { Box } from "@mui/material"

const Welcome = () => {
  const [isLoading, setIsLoading] = useState(true)

  const handleImageLoad = () => {
    setIsLoading(false)
  }

  const isQuiz = useFeatureFlagEnabled("onboarding_test_group")
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleClickRedirect = () => {
    console.log("Redirecting to /guest/create-event")
    if (isQuiz) {
      navigate("/quiz")
    } else {
      navigate("/guest/create-event")
    }
  }
  const handleOnboardingRedirection = () => {
    console.log("Redirecting to /onboarding")
    navigate("/user/onboarding")
  }
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: "100%" }}
    >
      <div
        className="bg-white p-3 d-flex flex-column align-items-center justify-content-center gap-3 mt-3"
        style={{
          width: "75%",
          minHeight: "70vh",
          borderRadius: "12px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <div className="border-rounded bg-white p-3 d-flex flex-column align-items-center justify-content-center gap-3 mt-3">
          {isLoading && (
            <Skeleton width="190px" height="150px" borderRadius="8px" />
          )}
          <img
            src={tryMazoom}
            width="180px"
            height="auto"
            style={{
              minHeight: "150px",
              minWidth: "100px",
              display: isLoading ? "none" : "block",
            }}
            onLoad={handleImageLoad}
            alt="Welcome Home"
          />
          {/* <h3 className="mb-1 ">{t("event.welcomeToMazoomApp")}</h3> */}
          <h3 className="mb-1 fs-4   text-black ">
            {t("event.welcomeToMazoomApp")}
          </h3>
          <h6 className="fw-light me-3 ms-3 text-muted">
            {t("choose_one_of_the_options_below", "Choose one of the options below")}
          </h6>
          <div className="d-flex flex-column gap-2 w-100 p-2">
            {/* <Link to="/guest/create-event" className="w-100"> */}
            {/* Next Button */}
            <Box display="flex" justifyContent="center" width="100%" mt={4}>
              <button
                type="submit"
                className="btn btn-dark w-100"
                onClick={handleOnboardingRedirection}
              >
                {t("event.getStarted")}
              </button>
            </Box>

            {/* </Link> */}
            <button
              className="w-100 btn bg-light text-dark"
              style={{ border: "1px solid #000000" }}
              onClick={() => navigate("/whatsapp-login")}
            >
              {t("event.seeMyInvites")} {" "}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
const WelcomeHome = () => {
  const isQuiz = useFeatureFlagEnabled("onboarding_test_group")

  // if (isQuiz) {
  //   return <WelcomeQuiz />
  // } else {
  //   return <Welcome />
  // }
  return <Welcome />
}

export default WelcomeHome
